<template>
  <div class="home_header_box" :class="[forDeatil ? 'detail' : '', forOrder ? 'forOrder' : '']">
    <div></div>
    <div class="content_box">
      <div class="logo">
        <img src="../../../../assets/newImage/zoodian_logo.png" style="cursor: pointer;"
          @click="$router.push('/NewHome')" />
        <span class="prod_desc">{{ $t('header.logo') }}</span>
      </div>
      <div class="router_bnt">
        <span class="center_btn" :class="pathSel == 1 ? 'sel' : ''" @click="toPage('/NewHome')">{{
    $t('header.booking')
  }}</span>
        <span class="center_btn" :class="pathSel == 2 ? 'sel' : ''" @click="toPage('/orderManage')">{{
    $t('header.order')
  }}</span>
      </div>
      <div class="setting_box">
        <!-- 暂时不上中英文切换 -->
        <!-- <span style="color: #848484;cursor: pointer;user-select: none;">
                                                                          <span class="lang" :class="langStyle ? '' : 'check'" @click="$common.changeLanguage('zh')">中</span>
                                                                          <span class="separate"></span>
                                                                          <span class="lang" :class="langStyle ? 'check' : ''" @click="$common.changeLanguage('en')">En</span>
                                                                        </span> -->
        <b2b-button style="height: 35px;line-height: 35px;font-size: 14px;width: 120px;" @click="$router.push('/Login')"
          v-if="!partnerInfo">
          <span>注册 / 登录</span>
          <img src="../../../../assets/newImage/jiantou_you.png" style="width: 14px; height:14px;margin-bottom: 3px;">
        </b2b-button>
        <div class="user_info" v-else>
          <img src="../../../../assets/newImage/touxiang.png" style="width: 20px;height: 20px;">
          <el-dropdown @command="clickMenu">
            <span class=" el-dropdown-link">
              <span class="user_name">{{ partnerInfo.companyName }}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="2">
                <img src="../../../../assets/newImage/dingdan.png" style="margin-right: 6px" class="img_n" />
                <img src="../../../../assets/newImage/dingdan_w.png" style="margin-right: 6px" class="img_w" />
                订单管理
              </el-dropdown-item>
              <el-dropdown-item command="3">
                <img src="../../../../assets/newImage/zhangdan.png" style="margin-right: 6px" class="img_n" />
                <img src="../../../../assets/newImage/zhangdan_w.png" style="margin-right: 6px" class="img_w" />
                额度变动明细
              </el-dropdown-item>
              <el-dropdown-item command="7">
                <img src="../../../../assets/newImage/workOrder.png" style="margin-right: 6px" class="img_n" />
                <img src="../../../../assets/newImage/workOrder_w.png" style="margin-right: 6px" class="img_w" />
                工单管理
              </el-dropdown-item>
              <el-dropdown-item command="1">
                <img src="../../../../assets/newImage/shezhi.png" style="margin-right: 6px" class="img_n" />
                <img src="../../../../assets/newImage/shezhi_w.png" style="margin-right: 6px" class="img_w" />
                账户管理
              </el-dropdown-item>
              <el-dropdown-item command="8" v-if="partnerInfo.settleWay === 1">
                <img src="../../../../assets/newImage/invoice.png" style="margin-right: 6px" class="img_n" />
                <img src="../../../../assets/newImage/invoice_w.png" style="margin-right: 6px" class="img_w" />
                发票管理
              </el-dropdown-item>
              <el-dropdown-item command="4">
                <img src="../../../../assets/newImage/lxrimg.png" style="margin-right: 6px" class="img_n" />
                <img src="../../../../assets/newImage/lxrimg_w.png" style="margin-right: 6px" class="img_w" />
                常用联系人
              </el-dropdown-item>
              <el-dropdown-item command="5" v-if="partnerInfo.personType == 1">
                <img src="../../../../assets/newImage/zhizhanghao.png" style="margin-right: 6px" class="img_n" />
                <img src="../../../../assets/newImage/zhizhanghao_w.png" style="margin-right: 6px" class="img_w" />
                子账号管理
              </el-dropdown-item>
              <el-dropdown-item command="6">
                <img src="../../../../assets/newImage/logout.png" style="margin-right: 6px" class="img_n" />
                <img src="../../../../assets/newImage/logout_w.png" style="margin-right: 6px" class="img_w" />
                退出
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <div></div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      partnerInfo: {}
    }
  },
  props: {
    forDeatil: {
      forDeatil: Boolean,
      default: false
    },
    forOrder: {
      forOrder: Boolean,
      default: false
    }
  },
  created () {
    this.partnerInfo = JSON.parse(localStorage.getItem('partnerInfo'))
  },
  methods: {
    clickMenu (e) {
      if (e == 1) {
        if (this.partnerInfo.personType == 1) {
          this.$router.push('/orderManage/AccountInfo')
        } else {
          this.$router.push('/orderManage/AccountSetting')
        }
      } else if (e == 2) {
        this.$router.push('/orderManage/OrderList')
      } else if (e == 3) {
        this.$router.push('/orderManage/BillDeatil')
      } else if (e == 4) {
        this.$router.push('/orderManage/Contacts')
      } else if (e == 5) {
        this.$router.push('/orderManage/SubAccount')
      } else if (e == 6) {
        this.$common.loginOut(true)
      } else if (e == 7) {
        this.$router.push('/orderManage/WorkOrderManage')
      } else if (e === '8') {
        this.$router.push('/orderManage/invoiceManage')
      }
    },
    toPage (path, e) {
      this.$router.push(`${path}`)
    }
  },
  computed: {
    langStyle () {
      return localStorage.getItem('lang') == 'en'
    },
    pathSel () {
      if (this.$route.fullPath.split('/', 2)[1] == 'orderDetail') {
        return 2
      }
      if (this.$route.fullPath.split('/', 2)[1] != 'orderManage') {
        return 1
      } else {
        return 2
      }
    }
  }
}
</script>

<style lang="less" scoped>
@media screen and (min-width: 992px) {
  .home_header_box.detail {
    grid-template-columns: 1fr 1364px 1fr;
  }

  .home_header_box.forOrder {
    grid-template-columns: 10% 1fr 10%;
  }

  .home_header_box {
    width: 100%;
    height: 70px;
    line-height: 70px;
    background-color: #fff;

    display: grid;
    grid-template-columns: auto 1180px auto;

    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;

    box-shadow: 0 2px 2px #e9e8e8;

    .content_box {
      display: grid;
      grid-template-columns: repeat(3, auto);
      font-family: '苹方';
      font-size: 14px;

      .prod_desc {
        margin-left: 10px;
        color: #aeaeae;
      }

      .center_btn {
        cursor: pointer;
        user-select: none;
        color: #848484;
        margin-right: 20px;
        border: 1px solid #fff;
        border-radius: 5px;
        padding: 8px 15px;
      }

      .router_bnt {
        text-align: center;
      }

      .center_btn.sel {
        border: 1px solid #e9e9e9;
        border-radius: 5px;
        padding: 8px 15px;
        color: #000;
      }

      .setting_box {
        display: grid;
        grid-template-columns: auto auto;
        align-items: center;
        justify-content: end;
        grid-column-gap: 30px;

        .separate::before {
          content: '';
          display: inline-block;
          width: 1px;
          height: 10px;
          border-left: #e9e9e9 1px dashed;
          margin: 0 12px;
        }

        .lang.check {
          color: #000;
        }

        .user_info {
          display: grid;
          grid-template-columns: repeat(2, auto);
          grid-column-gap: 10px;
          align-items: center;

          .el-dropdown-link {
            max-width: 100px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 992px) {
  .home_header_box {
    width: 100%;
    height: 70px;
    line-height: 70px;
    background-color: #fff;

    display: grid;
    grid-template-columns: 10% 1fr 10%;

    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;

    box-shadow: 0 2px 2px #aeaeae;

    .content_box {
      display: grid;
      grid-template-columns: repeat(2, auto);
      font-family: '苹方';
      text-align: center;
      font-size: 14px;

      .logo {
        display: none;
      }

      .center_btn {
        cursor: pointer;
        user-select: none;
        color: #848484;
        margin-right: 20px;
        border: 1px solid #fff;
        border-radius: 5px;
        padding: 8px 15px;
      }

      .router_bnt {
        text-align: left;
      }

      .center_btn.sel {
        border: 1px solid #e9e9e9;
        border-radius: 5px;
        padding: 8px 15px;
        color: #000;
      }

      .setting_box {
        display: grid;
        grid-template-columns: auto auto;
        align-items: center;
        justify-content: end;
        grid-column-gap: 30px;

        .separate::before {
          content: '';
          display: inline-block;
          width: 1px;
          height: 10px;
          border-left: #e9e9e9 1px dashed;
          margin: 0 12px;
        }

        .lang.check {
          color: #000;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/newPages/booking/components/HomeHeader.vue